import React from 'react';
import {useMatches} from '@remix-run/react';

//components
import {Link} from 'components/Link';
import SanityImage from 'components/SanityImage';

//domains
import type {SanityDocBlog} from 'domains/blog';

interface Props extends SanityDocBlog {
  type?: string;
  size?: string;
}

export default function BlogCard({
  blog_title,
  blog_categories,
  blog_description,
  blog_published_date,
  blog_tags,
  blog_thumbnail,
  blog_category,
  slug,
  type,
  size,
}: Props) {
  const categorySlug = blog_category?.slug?.current;
  const [root] = useMatches();
  const translation = root?.data?.translation;
  if (type === 'vertical') {
    return (
      <Link to={`/blogs/${categorySlug}/${slug.current}`}>
        <article className="grid grid-cols-3 md:grid-cols-1 gap-2 md:gap-5">
          <div className="blog__thumbnail col-span-1">
            {/* aspect-w-3 aspect-h-3 */}
            <div className="">
              <SanityImage
                layout="responsive"
                sizes={['50vw, 100vw']}
                src={blog_thumbnail?.asset._ref}
                alt={blog_title ?? ''}
                loading="lazy"
                className="h-full object-cover"
              />
            </div>
          </div>
          <div className="col-span-2">
            {size === 'small' ? (
              <>
                <h5 className="line-clamp-3 text-lg font-semibold">
                  {blog_title}
                </h5>
              </>
            ) : (
              <>
                <h3 className="text-md md:text-[20px] md:leading-[30px] font-semibold line-clamp-4 mb-[18px]">
                  {blog_title}
                </h3>
                <div className="hidden md:block">
                  <p className="text-md md:text-lg !leading-snug font-normal line-clamp-4">
                    {blog_description}
                  </p>
                  <p className="text-md md:text-lg !leading-snug font-normal text-hk-orange">
                    {translation?.read_more ?? 'read more'}
                  </p>
                </div>
              </>
            )}
          </div>
          {/* Mobile */}
          {size !== 'small' && (
            <div className="col-span-3 md:hidden">
              <p className="line-clamp-4 text-xs font-normal leading-snug">
                {blog_description}
              </p>
              {blog_description?.length > 233 && (
                <p className="text-xs font-normal text-hk-orange">
                  {translation?.read_more ?? 'read more'}
                </p>
              )}
            </div>
          )}
        </article>
      </Link>
    );
  }
  return (
    <Link to={`/blogs/${categorySlug}/${slug.current}`}>
      <article className="grid grid-cols-3 gap-2 md:gap-5">
        <div className="blog__thumbnail col-span-1">
          {/* aspect-w-3 aspect-h-2 */}
          <div className="">
            <SanityImage
              layout="responsive"
              sizes={['50vw, 100vw']}
              src={blog_thumbnail?.asset._ref}
              alt={blog_title ?? ''}
              loading="lazy"
              className="h-full object-cover"
            />
          </div>
        </div>
        <div className="col-span-2">
          {size === 'small' ? (
            <>
              <h5 className="line-clamp-3 mb-2 text-lg font-semibold">
                {blog_title}
              </h5>
              <p className="text-md md:text-lg !leading-snug font-normal">
                {translation?.on ?? 'on'} {blog_published_date}
              </p>
            </>
          ) : (
            <>
              <h3 className="text-md md:text-[20px] md:leading-[30px] font-semibold mb-1 md:mb-[18px]">
                {blog_title}
              </h3>
              <p className="text-md md:text-lg !leading-snug font-normal md:mb-2">
                <span className="text-xs md:text-lg">
                  {translation?.on ?? 'on'} {blog_published_date}
                </span>
              </p>
              <div className="hidden md:block">
                <p className="text-md md:text-lg !leading-snug font-normal line-clamp-4">
                  {blog_description}
                </p>

                <p className="text-xs font-normal text-hk-orange">
                  {translation?.read_more ?? 'read more'}
                </p>
              </div>
            </>
          )}
        </div>
        {/* Mobile */}
        {size !== 'small' && (
          <div className="col-span-3 md:hidden">
            <p className="line-clamp-4 text-xs font-normal leading-snug">
              {blog_description}
            </p>
            <p className="text-xs font-normal text-hk-orange">
              {translation?.read_more ?? 'read more'}
            </p>
          </div>
        )}
      </article>
    </Link>
  );
}
